import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle-star-gray",
  "use": "circle-star-gray-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"circle-star-gray\"><rect width=\"32\" height=\"32\" rx=\"16\" fill=\"#334158\" /><path d=\"M25.088 13.46a1.095 1.095 0 00-.888-.75l-4.984-.723-2.229-4.515a1.1 1.1 0 00-1.975-.001l-2.23 4.516-4.982.724a1.102 1.102 0 00-.61 1.879l3.606 3.515-.852 4.963a1.1 1.1 0 001.598 1.161L16 21.886l4.457 2.343a1.101 1.101 0 001.598-1.161l-.852-4.963 3.606-3.515a1.096 1.096 0 00.279-1.13z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol